import { IE_DISTRIBUTION_ACTION_TYPES, COMMON_ACTION_TYPES } from "../../_constants";

const INITIAL_STATE = {
    ieDistributionList: {
        isLoading: false,
        data: [],
    },
    ieDistribution: {
        isLoading: false,
        data: null,
    },
    addOrUpdateIEDistribution: {
        isProcessing: false,
        data: null,
    }
};
const ieDistributionReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        // GET IE DISTRIBUTION LIST
        case IE_DISTRIBUTION_ACTION_TYPES.GET_IE_DISTRIBUTION_LIST + COMMON_ACTION_TYPES.REQUEST:
            return {
                ...state,
                ieDistributionList: {
                    isLoading: true,
                    data: [],
                }
            };

        case IE_DISTRIBUTION_ACTION_TYPES.GET_IE_DISTRIBUTION_LIST + COMMON_ACTION_TYPES.SUCCESS:
            return {
                ...state,
                ieDistributionList: {
                    isLoading: false,
                    data: action.data
                }
            };

        case IE_DISTRIBUTION_ACTION_TYPES.GET_IE_DISTRIBUTION_LIST + COMMON_ACTION_TYPES.ERROR:
            return {
                ...state,
                ieDistributionList: {
                    isLoading: false,
                    data: []
                }
            };
        case IE_DISTRIBUTION_ACTION_TYPES.GET_IE_DISTRIBUTION_LIST + COMMON_ACTION_TYPES.CLEAR:
            return {
                ...state,
                ieDistributionList: {
                    isLoading: false,
                    data: []
                }
            };
        // GET IE DISTRIBUTION
        case IE_DISTRIBUTION_ACTION_TYPES.GET_IE_DISTRIBUTION + COMMON_ACTION_TYPES.REQUEST:
            return {
                ...state,
                ieDistribution: {
                    isLoading: true,
                    data: null,
                }
            };

        case IE_DISTRIBUTION_ACTION_TYPES.GET_IE_DISTRIBUTION + COMMON_ACTION_TYPES.SUCCESS:
            return {
                ...state,
                ieDistribution: {
                    isLoading: false,
                    data: action.data
                }
            };

        case IE_DISTRIBUTION_ACTION_TYPES.GET_IE_DISTRIBUTION + COMMON_ACTION_TYPES.ERROR:
            return {
                ...state,
                ieDistribution: {
                    isLoading: false,
                    data: null
                }
            };
        case IE_DISTRIBUTION_ACTION_TYPES.GET_IE_DISTRIBUTION + COMMON_ACTION_TYPES.CLEAR:
            return {
                ...state,
                ieDistribution: {
                    isLoading: false,
                    data: null
                }
            };
        // DELETE IE DISTRIBUTION
        case IE_DISTRIBUTION_ACTION_TYPES.DELETE_IE_DISTRIBUTION + COMMON_ACTION_TYPES.REQUEST:
            return state;

        case IE_DISTRIBUTION_ACTION_TYPES.DELETE_IE_DISTRIBUTION + COMMON_ACTION_TYPES.SUCCESS:
            return state;

        case IE_DISTRIBUTION_ACTION_TYPES.DELETE_IE_DISTRIBUTION + COMMON_ACTION_TYPES.ERROR:
            return state;
        // UPDATE PER WEEK HOURS
        case IE_DISTRIBUTION_ACTION_TYPES.UPDATE_PER_WEEK_HOURS + COMMON_ACTION_TYPES.REQUEST:
            return state;

        case IE_DISTRIBUTION_ACTION_TYPES.UPDATE_PER_WEEK_HOURS + COMMON_ACTION_TYPES.SUCCESS:
            return state;
        case IE_DISTRIBUTION_ACTION_TYPES.UPDATE_PER_WEEK_HOURS + COMMON_ACTION_TYPES.ERROR:
            return state;
        //    CREATE NEW IE DISTRIBUTION
        case IE_DISTRIBUTION_ACTION_TYPES.ADD_OR_UPDATE_IE_DISTRIBUTION + COMMON_ACTION_TYPES.REQUEST:
            return {
                ...state,
                addOrUpdateIEDistribution: {
                    isProcessing: true,
                    data: null,
                }
            };

        case IE_DISTRIBUTION_ACTION_TYPES.ADD_OR_UPDATE_IE_DISTRIBUTION + COMMON_ACTION_TYPES.SUCCESS:
            return {
                ...state,
                addOrUpdateIEDistribution: {
                    isProcessing: false,
                    data: action.data
                }
            };

        case IE_DISTRIBUTION_ACTION_TYPES.ADD_OR_UPDATE_IE_DISTRIBUTION + COMMON_ACTION_TYPES.ERROR:
            return {
                ...state,
                addOrUpdateIEDistribution: {
                    isProcessing: false,
                    data: null,
                }
            };
        default:
            return state;
    }
}

export default ieDistributionReducer;
